(function () {
  const DEFAULT_FOUNDER_PATH = '/pages/founder-100';
  const FOUNDER_PAGE_PATHS = [
    DEFAULT_FOUNDER_PATH,
    '/pages/founder-100',
    '/pages/wynn-club',
    '/pages/formwynn-founding-member-programme',
  ];
  const REDIRECT_DELAY_MS = 2800;
  const CART_ADD_FORM_SELECTOR = 'form[action*="/cart/add"]';
  const ADD_BUTTON_SELECTOR = [
    'button[name="add"]',
    'button[type="submit"]',
    'input[type="submit"]',
    '[data-add-to-cart]',
    '[data-testid*="add"]',
  ].join(',');

  let redirectTimer = null;

  function cleanPath(pathname) {
    return String(pathname || '').replace(/\/$/, '').toLowerCase();
  }

  function founderPath() {
    return cleanPath(window.FORMWYNN_FOUNDER_PATH || DEFAULT_FOUNDER_PATH);
  }

  function isFounderPage() {
    const currentPath = cleanPath(window.location.pathname);
    return currentPath === founderPath() || FOUNDER_PAGE_PATHS.includes(currentPath);
  }

  function isProductPage() {
    return cleanPath(window.location.pathname).startsWith('/products/');
  }

  function stopAddToCart(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function findCartAddForm(target) {
    return target?.closest?.(CART_ADD_FORM_SELECTOR) || null;
  }

  function ensureModal() {
    let modal = document.querySelector('[data-formwynn-founder-modal]');
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'formwynn-founder-modal';
    modal.dataset.formwynnFounderModal = 'true';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'formwynn-founder-modal-title');
    modal.innerHTML = `
      <div class="formwynn-founder-modal__panel">
        <p class="formwynn-founder-modal__eyebrow">FORMWYNN FOUNDERS</p>
        <h2 id="formwynn-founder-modal-title">This item is part of Founder 100</h2>
        <p>
          During our Founder 100 launch, all pieces are available exclusively through the
          Founder 100 collection — choose your set, and unlock member pricing.
        </p>
        <p class="formwynn-founder-modal__status">Taking you there now…</p>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  }

  function showFounderRedirectModal() {
    const modal = ensureModal();
    modal.classList.add('is-visible');
    document.documentElement.classList.add('formwynn-founder-modal-open');

    if (redirectTimer) window.clearTimeout(redirectTimer);
    redirectTimer = window.setTimeout(() => {
      window.location.href = founderPath();
    }, REDIRECT_DELAY_MS);
  }

  function shouldIntercept(target) {
    if (isFounderPage() || !isProductPage()) return false;
    return Boolean(findCartAddForm(target));
  }

  document.addEventListener(
    'submit',
    (event) => {
      if (!shouldIntercept(event.target)) return;
      stopAddToCart(event);
      showFounderRedirectModal();
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target?.closest?.(ADD_BUTTON_SELECTOR);
      if (!button || !shouldIntercept(button)) return;
      stopAddToCart(event);
      showFounderRedirectModal();
    },
    true,
  );
})();
